import { render, staticRenderFns } from "./PlayerHeader.vue?vue&type=template&id=45f02acc&scoped=true&"
import script from "./PlayerHeader.vue?vue&type=script&lang=js&"
export * from "./PlayerHeader.vue?vue&type=script&lang=js&"
import style0 from "./PlayerHeader.vue?vue&type=style&index=0&id=45f02acc&prod&scoped=true&lang=css&"
import style1 from "./PlayerHeader.vue?vue&type=style&index=1&id=45f02acc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f02acc",
  null
  
)

export default component.exports